<template>
  <Modal :closable="false">
    <div class="modal__shields">
      <ModalShield
        v-for="level in levels.length - 1"
        :key="level"
        :icon="
          levels[level].state === 'finish' ? 'prizeUnlocked' : 'prizeLocked'
        "
        :class="{ 'shield--active': levels[level].state === 'finish' }"
      />
      <ModalShield
        :icon="secretFound ? 'prizeUnlocked' : 'prizeLocked'"
        :class="['shield--secret', { 'shield--active': secretFound }]"
      />
    </div>

    <p>
      Вы только прибыли, а у нас уже есть для вас задание! Найдите и одолейте
      короля Алланта. Чтобы справиться с ним, сперва победите более слабых
      врагов.
    </p>

    <div class="modal__actions">
      <button
        class="button"
        data-size="big"
        @click="start"
        :data-pixel="pixels.startBtn"
      >
        Вперед!
      </button>
    </div>

    <img src="../assets/img/divider.svg" class="modal__divider" />
    <div class="modal__info">
      <p>А вы знали, что <span v-html="getRandomFact()" /></p>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import Modal from "./Modal";
import ModalShield from "./ModalShield";
import getRandomFact from "../helpers/getRandomFact";

export default {
  components: { Modal, ModalShield },
  data: function() {
    return {
      pixels: {
        startBtn:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizm&pr=%random%&ptrc=b"
      }
    };
  },
  computed: {
    ...mapState(["levelId", "levels"]),
    ...mapGetters(["secretFound"])
  },
  methods: {
    getRandomFact,
    ...mapMutations(["startLevel"]),
    start() {
      this.$metrika.showPixel(
        "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhjdf&pr=%random%&ptrc=b"
      );
      this.$store.commit("toggleModal", "intro");
      this.startLevel();

      const firstPlay = localStorage.getItem("firstPlay");

      if (this.levelId === 1 && !firstPlay) {
        localStorage.setItem("firstPlay", "1");
        setTimeout(() => this.$store.commit("toggleModal", "howToPlay"), 500);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__actions {
  .button {
    max-width: 225px;
  }
}
</style>
